import * as devisConf from '@/configuration/devisConf';
import creerIntervenant from '@/services/devis/creerIntervenant';
import defineTitreIntervenant from '@/services/devis/ajoutIntervenant/defineTitreIntervenant';

function creerIntervenantAnnonceur(client, intervenants) {
  const intervenant = creerIntervenant(client);
  intervenant.annonceur = true;
  intervenant.repartition = 0;
  intervenant.typeRepartition = devisConf.POURCENTAGE;
  defineTitreIntervenant(intervenant);

  const oldIntervenant = intervenants.find(i => i.annonceur && !i.payeur);
  if (oldIntervenant) intervenant.id = oldIntervenant.id;
  return intervenant;
}
function creerIntervenantPayeur(client, intervenants) {
  const intervenant = creerIntervenant(client);
  intervenant.payeur = true;
  intervenant.repartition = 100;
  intervenant.typeRepartition = devisConf.POURCENTAGE;

  const oldIntervenant = intervenants.find(i => i.payeur && !i.annonceur);
  if (oldIntervenant) intervenant.id = oldIntervenant.id;
  return intervenant;
}

export default function creerOrMajIntervenantDevis(devis, client) {
  const annonceur = creerIntervenantAnnonceur(client, devis.intervenants);
  const payeur = creerIntervenantPayeur(client.tiersParent, devis.intervenants);
  return [annonceur, payeur];
}
